import api from '@/api';

class Priority {
  static list() {
    return api.get('/actions/priorities');
  }
}

export default Priority;
